import ModalDimmed from './ModalDimmed';

type ModalPropsType = {
  onClickClose?: Function;
  onClose: Function;
  children: React.ReactNode;
  theme?: 'full' | 'small';
};

const makeTheme = (theme: string) => {
  return {
    full: 'w-full h-full',
    small: 'px-[24px] rounded-2xl',
  }[theme];
};

export default function Modal({
  onClickClose,
  onClose,
  children,
  theme = 'full',
}: ModalPropsType) {
  const handleClickCancel = () => {
    onClickClose && onClickClose();
    onClose();
  };

  return (
    <>
      <div
        className={`z-50 fixed top-1/2 left-1/2 -translate-x-1/2
                      -translate-y-1/2 overflow-x-hidden
                      mobile:w-max mobile:h-auto
                      border border_primary mobile:rounded-[16px]
                      shadow-s surface_primary overflow-y-auto
                      mobile:overflow-hidden mobile:justify-center
                      flex flex-col items-center
                      ${makeTheme(theme)}`}
      >
        {children}
      </div>
      <ModalDimmed onClose={handleClickCancel} />
    </>
  );
}
